import {
    HttpClient,
    provideHttpClient,
    withFetch,
    withInterceptors
} from '@angular/common/http';
import {
    ApplicationConfig,
    inject,
    provideAppInitializer
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
    provideRouter,
    withEnabledBlockingInitialNavigation,
    withInMemoryScrolling
} from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { DialogService } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';

import { fetchUser } from './app.initializer';
import { appRoutes } from './app.routes';

import {
    apiInterceptor,
    EncryptionInterceptor,
    xsrfInterceptor
} from '@/api/interceptors';
import { AuthInterceptor } from '@/auth/interceptors';
import AuthService from '@/auth/services/auth.service';
import { AppService } from '@/service/app.service';
import { CryptoService } from '@/service/crypto.service';
import { UIService } from '@/service/ui.service';

export interface AppConfig extends ApplicationConfig {
    name: string;
    short_name?: string;
}

export const appConfig: AppConfig = {
    providers: [
        provideRouter(
            appRoutes,
            withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
            withEnabledBlockingInitialNavigation()
        ),
        provideHttpClient(
            withFetch(),
            withInterceptors([
                apiInterceptor,
                AuthInterceptor,
                xsrfInterceptor,
                EncryptionInterceptor
            ])
        ),
        provideAnimationsAsync(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        provideAppInitializer(() => {
            const http = inject(HttpClient);
            const appService = inject(AppService);
            return firstValueFrom(
                http.get(
                    appService.environment.apiUrl.replace('/api', '') + '/sanctum/csrf-cookie',
                    { withCredentials: true }
                )
            );
        }),
        provideAppInitializer(() =>
            fetchUser(
                inject(UIService),
                inject(AuthService),
                inject(CryptoService)
            )()
        ),
        MessageService,
        DialogService,
    ],
    name: 'Point Quest Group',
    short_name: 'PQG'
};
